package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("plants_make_food")
@Composable
fun KidsPlantsMakeFoodPage() {
    BlogLayout(
        PageProperties(
            "Plants Make Food",
            ""
        ),
        BlogProperties("Kids", "Plants Make Food")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Word Galaxy",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Pair ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Two things together are known as pair.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Aerial ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "In the air, above the ground.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Food chain ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "A chain of organisms each dependent on the next as a source of food.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Global worming ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Increase in the temperature of the Earth.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Chlorophyll ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "A green pigment present in the Leaves which traps the sunlight.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stomata ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "The openings in the leaf which help in exchange of gases. Small openings present on the lower surface of leaves.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tissue ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Group of cells.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Heterotroph ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "An organism that obtains its food from other organisms.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Transpiration ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Release of extra water from the surface of leaves through stomata.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Lamina ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }


                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Xylem ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Phloem ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Glucose ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Coleus ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Fungi ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Heterotrophs ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Croton ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Match them",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Main vein – mid rib",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stalk - petiole",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Leaf blade – lamina",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Photosynthesis- chlorophyll",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Name the vein running through the middle of a leaf.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The vein running through the middle of a leaf is midrib.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "In which form is the food stored in the leaf?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Food is stored in the form of starch in a leaf.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Name the part of the plant that prepares food.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The leaf is the part of the plant that prepares food.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is photosynthesis?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Photosynthesis is the process by which plants prepare their own food using carbon dioxide and water in the presence of sunlight with the help of chlorophyll.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do plants control global warming?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Plants use the carbon dioxide gas present in the air and thus control the amount of carbon dioxide present in it. If plants did not use carbon dioxide, the air around us would have high level of carbon dioxide, which would in turn increase the temperature of the earth also kno as global warming.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are the materials used by plants during photosynthesis?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Plants use carbon dioxide, water and sunlight during photosynthesis.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the role of stomata in photosynthesis?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The role of stomata in photosynthesis is taking in carbon dioxide (Co2)giving out oxygen (O2) and excess water vapour",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain process of photosynthesis?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Plant take in carbon dioxide through stomata from the air.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "The roots of plants absorb water and minerals from the soil.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "Chlorophyll in the leaves traps energy from the sunlight.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "Chlorophyll in the leaves traps energy from the sunlight.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "The trapped energy helps the leaves prepare food for the plant making the, the food factories of the plant.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What happens to the extra food that is not used by the plant?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The extra food that the plant does not use because statch. It is stored in different parts of plant like the roots, stems or fruits.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Name the different parts of a leaf.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The different parts of a leaf are: Apex, Margin, Veins, Midrib, Base, Petiole, Stipule.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why does Venus flytrap eat insects?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Venus flytrap grows in the soil which is poor in minerals. So, it traps insects to get the required minerals.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Plants and gold fish are grown together in a fishbowl. Why?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Plants give oxygen to breathe and in turn gold fish breathe out carbon dioxide which is used by plants for photosynthesis",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "The leaves of croton and coleus plants are not green, but carry out photosynthesis. How?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The leaves of croton and coleus plants carry out photosynthesis because they also have chlorophyll but, it is masked by other pigments and is not visible.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What will happen if there are more animals than plants in nature?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "If there are more animals than plants in nature, there will be shortage of food and oxygen, and the amount of carbon dioxide will increase in the atmosphere. This increase will warm the atmosphere. ",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }
            }
        }
    }
}

//https://www.standrewsdelhi.com/assignment-&-worksheets.php
//https://standrewsdelhi.com/images/assignments/class-4/Science-%20L-1%20Food%20Making%20in%20Plants%20(IV).pdf
//Food Chain














